module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-MouseInCanyon-1280.a8896e81.jpg";